import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Routes } from "@angular/router";
import { DefaultComponent } from "../theme/pages/default/default.component";
import { LayoutModule } from "../theme/layouts/layout.module";
import { FormsModule } from "@angular/forms";
import { appService } from "../_services/app.service";
import { NgxBarcodeModule } from "ngx-barcode";
import { CommonService } from "../_services/common.service";
import { HttpClient } from "@angular/common/http";
import { RatingModule } from "ngx-bootstrap";
import { TranslateLoader, TranslateModule, TranslateService, } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../theme/home/translateConfig.service";
import { PrintInvoiceComponent } from "./print-invoice.component";
import { PrintInvoiceRoutingModule } from "./print-invoice-routing.routing";
import { NumberToWordsPipe } from "./number-to-words.pipe";
import { QRCodeModule } from "angularx-qrcode";
import { PrintFormatsModule } from "../print-formats/print-formats.module";
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}

// const routes: Routes = [
//   {
//     path: "",
//     component: DefaultComponent,
//     children: [
//       {
//         path: "",
//         component: LiveTrackingComponent,
//       },
//     ],
//   },
// ];

@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        FormsModule,
        RatingModule,
        PrintInvoiceRoutingModule,
        NgxBarcodeModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        PrintFormatsModule,
        QRCodeModule
    ],
    exports: [PrintInvoiceComponent],
    declarations: [PrintInvoiceComponent, NumberToWordsPipe],
    providers: [appService, CommonService, DatePipe, TranslateConfigService],
})
export class PrintInvoiceModule { }
